import { Navigate } from 'react-router-dom';
import { BrandLoader } from './ui/BrandLoader';
import { useZktecoAccess, useZktecoFlagSettled } from '../utils/zktecoAccess';

/**
 * Feature guard for `/attendance/device-sync` (owner decision 2026-09-29): only a company with a ZKTeco
 * connection has the page. Same three-state shape as HourlyPayRoute: a cached "connected" admits at once; a
 * cached "not connected" waits (bounded) for the live GetUserInfo answer rather than bouncing a deep link;
 * otherwise it redirects home. UX only: the ZKTeco endpoints keep their own checks.
 *
 * Compose INSIDE RoleProtectedRoute: role first, feature second.
 */
export const DeviceSyncRoute = ({ children }: { children: React.ReactElement }) => {
  const access = useZktecoAccess();
  const settled = useZktecoFlagSettled(access.live);

  if (access.connected) return children;
  if (!settled) {
    return (
      <div className="flex flex-1 items-center justify-center p-6">
        <BrandLoader variant="inline" size="md" />
      </div>
    );
  }
  return <Navigate to="/" replace />;
};

export default DeviceSyncRoute;
